// frontend/core/module-registry.ts
import { create } from 'zustand'
import { RouteObject } from 'react-router-dom'
import { ModuleConfig } from './module'

interface ModuleRegistry {
    modules: Record<string, ModuleConfig>;
    registerModule: (module: ModuleConfig) => void;
    unregisterModule: (moduleName: string) => void;
    getModule: (moduleName: string) => ModuleConfig | undefined;
    getAllRoutes: () => RouteObject[];
}

export const useModuleRegistry = create<ModuleRegistry>((set, get) => ({
    modules: {},
    registerModule: (module) => {
        set((state) => ({
            modules: {
                ...state.modules,
                [module.name]: module,
            },
        }));
        module.initialize?.();
    },
    unregisterModule: (moduleName) => {
        const module = get().modules[moduleName];
        module?.cleanup?.();
        set((state) => {
            const { [moduleName]: _, ...remainingModules } = state.modules;
            return { modules: remainingModules };
        });
    },
    getModule: (moduleName) => get().modules[moduleName],
    getAllRoutes: () => {
        return Object.values(get().modules).flatMap(module => module.routes);
    },
}));
